import React from "react";

import "./style.scss";

const Index = () => {
  return (
    <section className="article-section terms">
      <div className="inner-article-container">
        <div className="snippet-container">
          <h1 className="article-title">Brukervilkår (lisensavtale)</h1>
          <p className="article-text">
            Leadfind AS (Org. 935 103 134) er et foretak som er registert i
            Norge og som leverer tjenesten leadfind.no. Dette er et digitalt
            bedriftsverktøy som hjelper deg med å komme i kontakt med norske
            foretak og samarbeide internt i ditt eget selskap med formål om å
            forenkle salg, markedsføring eller andre relaterte ytelser. Kunden
            vil mot betaling få tilgang til tjenesten og all tilhørende
            funksjonalitet basert på hvilke rolle man har i selskapet man
            representerer. Ved hjelp av offentlig tilgjengelig informasjon og
            egne løsninger for prosessering og innhenting av
            tilleggsopplysninger til bedrifter gir vi tilgang på dette gjennom
            tjenesten vår.
            <br />
            <br />
            Leadfind er en tjeneste som gjør det lettere for bedrifter å finne
            og komme i kontakt med potensielle kunder, samtidig som det legger
            til rette for internt samarbeid og effektive løsninger slik at
            bedrifter kan få enda bedre resultater. Til sammen utgjør vår
            utforming, funksjonalitet og intuitive løsninger, sammen med
            tredjepartsdata tjenesten "Leadfind".
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Aksept av avtale</h3>
          <p className="article-text">
            Når du aksepterer denne avtalen godtar du vilkårene i avtalen og det
            blir inngått en juridisk bindende avtale mellom deg (kunden) og
            Leadfind (Leadfind AS, 935 103 134). Denne avtalen regulerer din
            bruksrett av tjenesten, og ved å merke av "Jeg godtar
            brukervilkårene" under registrering, aksepterer du denne avtalen.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Krav om bruk</h3>
          <p className="article-text">
            Før du tar i bruk tjenesten stilles det noen krav til deg som
            forbruker til hva som kreves for å benytte deg av tjenesten og
            hvordan du skal bruke den. Nedenfor finner du en oversikt over våre
            krav for bruk:
          </p>
          <ol>
            <li>
              Du må være myndig (over 18 år) for å benytte deg av denne
              tjenesten.
            </li>
            <li>
              Du må være et menneske, da vi ikke tillater automatisert software,
              macro eller utvidelser på/av/for vår tjeneste.
            </li>
            <li>
              Du må oppgi dine ekte personopplysninger som navn, e-postadresse
              og lignende informasjon ved registrering.
            </li>
            <li>
              Din konto kan kun benyttes av èn person, og skal alltid kun
              tilhøre èn person. Ved mistanke om deling av kontoer vil brukeren
              bli stengt ned umiddelbart og du vil ikke ha krav på refundering.
            </li>
            <li>
              Du er selv ansvarlig for å vedlikeholde sikkerheten rundt din egen
              konto.
            </li>
            <li>
              Du er selv ansvarlig for alt innhold som blir publisert og
              aktiviteter som skjer i sammenheng med bruk av tjenesten.
            </li>
            <li>
              Du skal ikke bruke denne tjenesten til kriminell aktivitet eller
              noe som bryter med enten våre eller juridiske retningslinjer.
            </li>
          </ol>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Tilgang til tjenesten</h3>
          <p className="article-text">
            Ved å akseptere denne avtalen får du tilgang til tjenesten, og du
            vil fra start av abonnement få en ikke-eksklusiv bruksrett til å
            benytte deg av Leadfind for egen virksomhet. Ved et aktivt
            abonnement skal Leadfind gi deg full tilgang til tjenesten, og
            samtidig bistå med teknisk support dersom det er behov for dette. Du
            er å anse som en lisenseier kun ved et aktivt abonnement, og du vil
            ha tilgang til tjenesten alle dager i året uten noen begrensninger.{" "}
            <br />
            <br />
            Det kan forekomme at Leadfind vil ha nedetid, selvom det er ytterst
            sjeldent. Dersom du kan dokumentere at din tilgang har blitt
            merkbart redusert som følge av vår nedetid vil det åpne seg
            muligheter for å diskutere en kompensasjon i form av lavere
            fremtidig lisenspris over en gitt tidsperiode for å gjøre opp for
            dette.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Opphavsrett</h3>
          <p className="article-text">
            Leadfind AS eier Leadfind og har opphavsrett til denne tjenesten.
            Denne opphavsretten er beskyttet i lov om opphavsrett til åndsverk.
            Eiendomsretten til tjenesten tilhører Leadfind AS, uavhengig av
            lisensiering av tjenesten til kunden i henhold til avtalen, som også
            gjelder både for originalversjon og eventuelle kopier. Ved bruk av
            denne tjenesten er du forpliktet til å behandle tjenesten som et
            hvert annet opphavsrettslig beskyttet materiale, og du skal ikke
            kopiere materiale fra Leadfind uten å oppgi kilder eller få et
            skriftlig samtykke fra Leadfind AS.
            <br />
            <br />
            Som bruker har du heller ikke, under noen omstendigheter, lov til å
            selge eller overføre noe fra tjenesten over til en annen tredjepart
            eller virksomhet. Det er heller ikke under noen omstendigheter
            tillatt å dekompilere, reverse-engineere, bygge videre på eller dele
            opp noe av Leadfind-tjenesten, da dette er å anse som privat
            eiendom. All kontaktinformasjon som blir lagret hos Leadfind er å
            anse som våres eiendom, hvor data utenom er å anse som din (kunden)
            sin eiendom.{" "}
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Lisens</h3>
          <p className="article-text">
            For tilgang til Leadfind skal det betales en månedlig lisensavgift
            til Leadfind AS, som betales med betalingskort gjennom Stripe. Etter
            betaling vil du umiddelbart få tilgang til hele plattformen, og du
            vil fra datoen du starter abonnementet bli belastet èn gang hver
            måned for antall brukertilganger du har kjøpt. Etter kjøp har du
            ikke krav på refusjon, og dersom du ønsker å kansellere abonnementet
            ditt må dette gjøres før neste månedlige trekk.
            <br />
            <br />
            Ved kansellering vil abonnementet ditt automatisk bli stoppet, så
            lenge du ikke har noe utestående hos oss. I denne avtalen regnes èn
            bruker som en samarbeidspartner eller en person i et annet foretak
            med eksklusiv tilgang, og denne kan justeres både i
            registreringsprosessen og endres i etterkant.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Varighet og oppsigelse</h3>
          <p className="article-text">
            Lisensen til Leadfind er gyldig èn måned om gangen, og fornyes
            automatisk dersom du har et aktivit abonnement og ikke har valgt å
            terminere det. Du har ikke krav på refusjon etter kjøpet er
            gjennomført, men står fritt til å si opp abonnementet ditt når som
            helst. Når du registrerer ny bruker hos Leadfind og benytter deg av
            30 dagers gratis prøvetid, vil du bli fakturert automatisk etter
            denne perioden dersom du ikke kansellerer manuelt i forkant.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Ansvarsbegrensning</h3>
          <p className="article-text">
            Leadfind (Leadfind AS, 935 103 134) fraskriver seg alt ansvar for
            ethvert tap, skade eller uhell som oppstår av kundens bruk av
            tjenesten, herunder, men ikke begrenset til feil i bedriftstall,
            kontaktinformasjon, eller annen feil som kommer fra en tredjepart.
            Dette gjelder også alt som er utenfor Leadfind sin kontroll, som for
            eksempel manglende teknisk kunnskap, begrensninger på teknisk utstyr
            o.l.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Mislighold</h3>
          <p className="article-text">
            Dersom kunden motsetter seg eller av en annen grunn ikke betaler den
            månedlige lisensavgiften, har Leadfind rett til å hindre brukeren
            tilgang til tjenesten med umiddelbar virkning frem det utestående
            blir gjort opp, hvor i enkelte tilfeller renter og omkostninger vil
            foreligge. Ved ekstraordinære situasjoner som etter alminnelige
            regler må regnes som force majeure, anses ikke avtalen misligholdt
            så lenge force majeure situasjonen fortsatt er tilstede.
            <br />
            <br />
            Skulle situasjonen vedvare, eller hvis det er antydninger til at det
            vil pågå i mer enn 30 dager kan hver av partene si opp avtalen med
            30 dagers forvarsel.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Overdragelse</h3>
          <p className="article-text">
            Kunden kan ikke under noen omstendigheter overføre avtalen til en
            annen fysisk eller juridisk person, ei heller en tredjepart uten
            skriftlig samtykke fra Leadfind (Leadfind AS).
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Generelt</h3>
          <p className="article-text">
            Denne avtalen erstatter alle eventuelle tidligere avtaler og
            forpliktelser, både muntlige og skriftlige, vedrørende tilgang til
            tjenesten både i regi av brukertilganger og pris. Denne avtalen
            reguleres av norsk lov, og tillegg eller endringer i avtalen er kun
            gyldig dersom ny, skriftlig avtale med henvisning til avtalen
            foreligger. Denne avtalen er bindende og skal ved eventuelle
            konflikter avgjøres etter norsk rett og vedtas ved Oslo Tingrett.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Index;
